export default __webpack_public_path__ + "static/help_04_01-d9fb44df6679ee68428cf51e09cf4abe.png";